export default __webpack_public_path__ + "static/media/Galaxy flare2.524bdb33.jpg";